// /src/utils/browserUtils.js

// 카카오톡과 네이버 인앱 브라우저 감지
export function isKakaoNaverInAppBrowser() {
  const userAgent = navigator.userAgent || '';
  return (/KAKAOTALK|NAVER/iu).test(userAgent);
}

// 특정 인앱 브라우저 감지 함수
export function isSpecificInAppBrowser(browserName) {
  const userAgent = navigator.userAgent || '';
  const regex = new RegExp(browserName, 'iu'); // 대소문자 구분 없이, Unicode 지원
  return regex.test(userAgent);
}

// 웹뷰 환경 감지 함수
export function isInAppBrowser() {
  const userAgent = navigator.userAgent || '';
  const inAppBrowserKeywords = [
    'KAKAOTALK',
    'NAVER',
    'Instagram',
    'Line',
    'Twitter',
    'LinkedIn',
    'Snapchat',
    'WeChat',
    'Weibo',
    'QQ',
    'baidubrowser',
    'UCBrowser',
    'MiuiBrowser',
    'Alipay',
    'Nintendo',
    'Xbox',
    'Zalo',
    'Facebook',
  ];

  // 대소문자 구분 없이 userAgent에 포함된 키워드를 탐색
  return inAppBrowserKeywords.some(browser => new RegExp(browser, 'iu').test(userAgent));
}
